import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ArrowLeft, Check, X } from 'lucide-react';
import './LegalPages.css';

const Cookies = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          <span>Înapoi la Pagina Principală</span>
        </Link>

        <div className="legal-header">
          <Cookie size={48} />
          <h1>Politica de Cookies</h1>
          <p className="legal-updated">Ultima actualizare: 25 August 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Ce Sunt Cookies?</h2>
            <p>
              Cookies sunt fișiere text de mici dimensiuni stocate pe dispozitivul dumneavoastră
              (computer, tabletă, smartphone) când vizitați site-uri web sau utilizați aplicații.
              Acestea permit site-ului să își "amintească" acțiunile și preferințele dumneavoastră
              (cum ar fi limba, dimensiunea fontului și alte preferințe de afișare) pentru o perioadă
              de timp.
            </p>
            <div className="company-info">
              <h3>Operator:</h3>
              <ul>
                <li><strong>MULTIPOWER TOUR SRL</strong></li>
                <li>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani, România</li>
                <li>Tel: +4-0740-824.224</li>
                <li>Email: multipowertour@yahoo.com</li>
                <li>Web: https://multipowertour.ro</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. De Ce Folosim Cookies?</h2>
            <p>
              Utilizăm cookies pentru a:
            </p>
            <ul>
              <li>Asigura funcționarea corectă a site-ului și aplicației</li>
              <li>Păstra sesiunea de autentificare activă</li>
              <li>Reține preferințele și setările dumneavoastră</li>
              <li>Îmbunătăți experiența de utilizare</li>
              <li>Analiza traficul și comportamentul utilizatorilor</li>
              <li>Personaliza conținutul și reclamele</li>
              <li>Asigura securitatea contului</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Tipuri de Cookies Utilizate</h2>

            <div className="cookie-category">
              <div className="cookie-header essential">
                <Check size={24} />
                <h3>Cookies Strict Necesare (Esențiale)</h3>
                <span className="cookie-status required">Obligatorii</span>
              </div>
              <p>
                Aceste cookies sunt esențiale pentru funcționarea site-ului și nu pot fi dezactivate.
                Sunt setate ca răspuns la acțiuni precum autentificarea, securitatea și accesarea
                funcțiilor de bază.
              </p>
              <table className="cookies-table">
                <thead>
                  <tr>
                    <th>Nume Cookie</th>
                    <th>Scop</th>
                    <th>Durată</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>session_id</td>
                    <td>Menține sesiunea utilizatorului autentificat</td>
                    <td>Sesiune</td>
                  </tr>
                  <tr>
                    <td>csrf_token</td>
                    <td>Protecție împotriva atacurilor CSRF</td>
                    <td>Sesiune</td>
                  </tr>
                  <tr>
                    <td>cookie_consent</td>
                    <td>Stochează preferințele de cookies</td>
                    <td>1 an</td>
                  </tr>
                  <tr>
                    <td>auth_token</td>
                    <td>Token de autentificare securizat</td>
                    <td>7 zile</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="cookie-category">
              <div className="cookie-header functional">
                <Check size={24} />
                <h3>Cookies Funcționale</h3>
                <span className="cookie-status optional">Opționale</span>
              </div>
              <p>
                Aceste cookies permit funcționalități îmbunătățite și personalizare, cum ar fi
                păstrarea limbii preferate sau a setărilor de afișare.
              </p>
              <table className="cookies-table">
                <thead>
                  <tr>
                    <th>Nume Cookie</th>
                    <th>Scop</th>
                    <th>Durată</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>user_language</td>
                    <td>Păstrează limba selectată</td>
                    <td>1 an</td>
                  </tr>
                  <tr>
                    <td>theme_preference</td>
                    <td>Tema preferată (light/dark mode)</td>
                    <td>1 an</td>
                  </tr>
                  <tr>
                    <td>location_saved</td>
                    <td>Locații favorite salvate</td>
                    <td>6 luni</td>
                  </tr>
                  <tr>
                    <td>recent_routes</td>
                    <td>Rute căutate recent</td>
                    <td>30 zile</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="cookie-category">
              <div className="cookie-header analytics">
                <Check size={24} />
                <h3>Cookies Analitice/Performanță</h3>
                <span className="cookie-status optional">Opționale</span>
              </div>
              <p>
                Aceste cookies ne ajută să înțelegem cum utilizați site-ul, ce pagini vizitați
                și unde întâmpinați probleme, pentru a îmbunătăți performanța.
              </p>
              <table className="cookies-table">
                <thead>
                  <tr>
                    <th>Nume Cookie</th>
                    <th>Furnizor</th>
                    <th>Scop</th>
                    <th>Durată</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>_ga</td>
                    <td>Google Analytics</td>
                    <td>Distinge utilizatorii unici</td>
                    <td>2 ani</td>
                  </tr>
                  <tr>
                    <td>_ga_*</td>
                    <td>Google Analytics</td>
                    <td>Persistență stare sesiune</td>
                    <td>2 ani</td>
                  </tr>
                  <tr>
                    <td>_gid</td>
                    <td>Google Analytics</td>
                    <td>Distinge utilizatorii</td>
                    <td>24 ore</td>
                  </tr>
                  <tr>
                    <td>_gat</td>
                    <td>Google Analytics</td>
                    <td>Limitare rata cereri</td>
                    <td>1 minut</td>
                  </tr>
                </tbody>
              </table>
              <p className="cookie-note">
                <strong>Notă:</strong> Datele colectate prin Google Analytics sunt anonimizate
                (IP anonimizat) și folosite exclusiv pentru statistici agregate.
              </p>
            </div>

            <div className="cookie-category">
              <div className="cookie-header marketing">
                <X size={24} />
                <h3>Cookies de Marketing/Publicitate</h3>
                <span className="cookie-status optional">Opționale</span>
              </div>
              <p>
                În prezent, <strong>NU folosim cookies de marketing sau publicitate terță parte</strong>.
                Dacă în viitor vom introduce astfel de cookies, veți fi notificați și vi se va cere
                consimțământul explicit.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>4. Cookies de la Terțe Părți</h2>
            <p>
              Pe lângă cookies proprii, utilizăm și cookies de la servicii terțe părți:
            </p>

            <h3>Google Analytics</h3>
            <ul>
              <li><strong>Scop:</strong> Analiză trafic și comportament utilizatori</li>
              <li><strong>Date colectate:</strong> Pagini vizitate, timp pe site, date demografice anonime</li>
              <li><strong>Anonimizare IP:</strong> Activată (ultimul octet este eliminat)</li>
              <li><strong>Politica lor:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
              <li><strong>Opt-out:</strong> <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out</a></li>
            </ul>

            <h3>Stripe (Procesare Plăți)</h3>
            <ul>
              <li><strong>Scop:</strong> Procesare securizată plăți cu cardul</li>
              <li><strong>Date colectate:</strong> Date tranzacții, prevenire fraudă</li>
              <li><strong>Securitate:</strong> PCI DSS Level 1 certificat</li>
              <li><strong>Politica lor:</strong> <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a></li>
            </ul>

            <h3>Google Maps</h3>
            <ul>
              <li><strong>Scop:</strong> Afișare hărți și calculare rute</li>
              <li><strong>Date colectate:</strong> Locație (cu permisiune), interacțiuni hartă</li>
              <li><strong>Politica lor:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Durata de Stocare a Cookies</h2>
            <p>
              Cookies pot fi:
            </p>

            <h3>Cookies de Sesiune</h3>
            <p>
              Sunt temporare și sunt șterse automat când închideți browser-ul. Folosite pentru
              autentificare și navigare de bază.
            </p>

            <h3>Cookies Persistente</h3>
            <p>
              Rămân pe dispozitiv până la expirare sau până când le ștergeți manual. Durata variază
              de la 24 de ore până la 2 ani, în funcție de scop.
            </p>

            <table className="duration-table">
              <thead>
                <tr>
                  <th>Durată</th>
                  <th>Tipuri Cookies</th>
                  <th>Exemplu</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sesiune</td>
                  <td>Esențiale</td>
                  <td>session_id, csrf_token</td>
                </tr>
                <tr>
                  <td>24 ore - 30 zile</td>
                  <td>Funcționale</td>
                  <td>recent_routes, _gid</td>
                </tr>
                <tr>
                  <td>6 luni - 1 an</td>
                  <td>Funcționale</td>
                  <td>user_language, cookie_consent</td>
                </tr>
                <tr>
                  <td>2 ani</td>
                  <td>Analitice</td>
                  <td>_ga, _ga_*</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="legal-section">
            <h2>6. Gestionarea Preferințelor de Cookies</h2>

            <h3>6.1 Prin Panoul Nostru de Cookies</h3>
            <p>
              Puteți gestiona preferințele de cookies oricând accesând:
            </p>
            <ul>
              <li>Banner-ul de cookies la prima vizită</li>
              <li>Footer → "Setări Cookies"</li>
              <li>Setări Cont → Confidențialitate → Preferințe Cookies</li>
            </ul>
            <button className="action-button primary">Deschide Setări Cookies</button>

            <h3>6.2 Prin Browser</h3>
            <p>
              Majoritatea browserelor permit controlul cookies prin setări. Iată ghiduri pentru
              browsere populare:
            </p>

            <div className="browser-guides">
              <div className="browser-card">
                <h4>Google Chrome</h4>
                <p>Setări → Confidențialitate și securitate → Cookies și alte date ale site-ului</p>
                <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
                  Ghid complet →
                </a>
              </div>

              <div className="browser-card">
                <h4>Mozilla Firefox</h4>
                <p>Setări → Confidențialitate și securitate → Cookies și date ale site-ului</p>
                <a href="https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">
                  Ghid complet →
                </a>
              </div>

              <div className="browser-card">
                <h4>Safari</h4>
                <p>Preferințe → Confidențialitate → Gestionare date site</p>
                <a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer">
                  Ghid complet →
                </a>
              </div>

              <div className="browser-card">
                <h4>Microsoft Edge</h4>
                <p>Setări → Cookies și permisiuni site</p>
                <a href="https://support.microsoft.com/microsoft-edge/delete-cookies-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">
                  Ghid complet →
                </a>
              </div>
            </div>

            <h3>6.3 Opt-out Universal</h3>
            <p>
              Pentru opt-out din tracking publicitar, puteți vizita:
            </p>
            <ul>
              <li><a href="http://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">Your Online Choices</a></li>
              <li><a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer">Network Advertising Initiative</a></li>
              <li><a href="http://optout.aboutads.info/" target="_blank" rel="noopener noreferrer">Digital Advertising Alliance</a></li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Consecințele Dezactivării Cookies</h2>

            <h3>Cookies Esențiale Dezactivate:</h3>
            <div className="warning-box">
              <X size={24} />
              <div>
                <h4>Funcționalități Afectate:</h4>
                <ul>
                  <li>Nu vă puteți autentifica în cont</li>
                  <li>Nu puteți achiziționa bilete online</li>
                  <li>Preferințele nu vor fi salvate</li>
                  <li>Funcțiile de securitate pot fi compromise</li>
                </ul>
              </div>
            </div>

            <h3>Cookies Funcționale Dezactivate:</h3>
            <div className="info-box">
              <p>
                Site-ul va funcționa, dar va trebui să resetați preferințele (limba, tema) la fiecare vizită.
                Rutele recente și locațiile favorite nu vor fi salvate.
              </p>
            </div>

            <h3>Cookies Analitice Dezactivate:</h3>
            <div className="info-box">
              <p>
                Nu va afecta funcționalitatea, dar ne va împiedica să îmbunătățim serviciul pe baza
                datelor de utilizare.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>8. Cookies în Aplicația Mobilă</h2>
            <p>
              Aplicația mobilă Multipower Tour folosește tehnologii similare cookies pentru:
            </p>
            <ul>
              <li>Stocarea token-ului de autentificare</li>
              <li>Păstrarea preferințelor locale</li>
              <li>Cache-ul datelor pentru funcționare offline</li>
              <li>Analiză utilizare (cu consimțământul dvs.)</li>
            </ul>
            <p>
              Puteți gestiona aceste setări din: <strong>Aplicație → Setări → Confidențialitate</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Actualizări ale Politicii</h2>
            <p>
              Ne rezervăm dreptul de a actualiza această Politică de Cookies pentru a reflecta
              schimbări în tehnologie, legislație sau practicile noastre. Veți fi notificați
              prin:
            </p>
            <ul>
              <li>Banner pe site la următoarea vizită</li>
              <li>Notificare în aplicația mobilă</li>
              <li>Email (pentru modificări substanțiale)</li>
            </ul>
            <p>
              Data ultimei actualizări este afișată în partea de sus a acestui document.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Legislație Aplicabilă</h2>
            <p>
              Această Politică de Cookies respectă:
            </p>
            <ul>
              <li><strong>GDPR</strong> (Regulamentul UE 2016/679)</li>
              <li><strong>ePrivacy Directive</strong> (Directiva 2002/58/EC)</li>
              <li><strong>Legea nr. 506/2004</strong> privind prelucrarea datelor în România</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Contact</h2>
            <p>
              Pentru întrebări despre utilizarea cookies sau pentru exercitarea drepturilor GDPR:
            </p>
            <div className="contact-box">
              <p><strong>MULTIPOWER TOUR SRL</strong></p>
              <p>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani, România</p>
              <p>Telefon: <a href="tel:+40740824224">+4-0740-824.224</a></p>
              <p>Email: <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a></p>
              <p>Subiect: "Întrebări Cookies"</p>
              <p>Web: <a href="https://multipowertour.ro">https://multipowertour.ro</a></p>
            </div>
          </section>

          <div className="legal-footer">
            <p>
              Prin continuarea utilizării site-ului și aplicației noastre, confirmați că ați citit
              și înțeles această Politică de Cookies.
            </p>
          </div>
        </div>

        <div className="legal-navigation">
          <Link to="/termeni" className="legal-nav-link">
            ← Termeni și Condiții
          </Link>
          <Link to="/confidentialitate" className="legal-nav-link">
            ← Politica de Confidențialitate
          </Link>
          <Link to="/gdpr" className="legal-nav-link">
            ← GDPR
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
